import { queryClient } from './lib/queryClient';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { watchChunkLoadErrors } from './lib/chunkReload';
import { markPlatform } from './lib/platform';
import { watchWindowInsets } from './lib/windowInsets';
import { ensureLocaleLoaded, getLocale, subscribeLocale } from './i18n';
import './styles/global.css';
import './components/ui/ui.css';

// Az index.html indítási őrének jelezzük, hogy a JavaScript modul betöltődött.
document.documentElement.dataset.grundoBooted = 'true';

/* A platformfüggő elrendezési tokenekhez (dokk alsó távolsága) — lásd
   `markPlatform`. A render ELŐTT fut, hogy ne legyen egy képkockányi ugrás. */
markPlatform();

/* Androidon a rendszersávok valódi magassága csak natívan tudható meg — az
   indoklás a `windowInsets.ts`-ben. Más platformon nem csinál semmit. */
watchWindowInsets();

/**
 * Telepítés közben nyitva hagyott app: a lustán töltött képernyők a RÉGI
 * chunk-nevet kérnék, ami már nincs kiszolgálva. Egyetlen újratöltés megoldja
 * — a részletek és a huroktörés a `chunkReload.ts`-ben.
 */
watchChunkLoadErrors();

/* Az admin saját aldomainje (`admin.grundoapp.com`, docs/06 → Admin felület)
   ugyanezt az appot kapja; a gyökér ott az admin felületre vigyen. A render
   ELŐTT, hogy a router már az új útvonalat lássa. */
if (window.location.hostname.startsWith('admin.') && window.location.pathname === '/') {
  window.history.replaceState(null, '', `/admin${window.location.search}${window.location.hash}`);
}

/* `<html lang>` follows the UI language (screen readers, hyphenation). */
const syncDocumentLanguage = () => {
  document.documentElement.lang = getLocale();
};
subscribeLocale(syncDocumentLanguage);

const root = document.getElementById('root');
if (!root) throw new Error('#root nem található');

/* A non-Hungarian UI waits for its (local, lazy) dictionary chunk, so the
   first paint is not Hungarian for a split second. Hungarian resolves at once. */
void ensureLocaleLoaded().finally(() => {
  syncDocumentLanguage();
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppErrorBoundary>
          <App />
        </AppErrorBoundary>
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
